export function isLessonEditable(startAtLocal: Date, restrictiveDate: Date | null): boolean {
  return restrictiveDate ? startAtLocal > restrictiveDate : true;
}
